import React, { FC } from "react";

interface TextInputProps {
  value?: string;
  onChange?: (value: string) => void;
  onKeyDown?: {
    [key: string]: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  };
  onBlur?: () => void;
  onFocus?: (event: React.FocusEvent) => void;
}

export const TextInput: FC<TextInputProps> = ({ value = "", onChange, onKeyDown, onBlur, onFocus }) => {
  const [textValue, setTextValue] = React.useState(value);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (onKeyDown && onKeyDown[event.key]) {
      onKeyDown[event.key](event);
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTextValue(event.target.value);
    onChange && onChange(event.target.value);
  };

  return (
    <input
      autoFocus
      type="text"
      value={textValue}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      onBlur={() => onBlur && onBlur()}
      onFocus={(e) => onFocus && onFocus(e)}
    />
  );
};
